import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { TipoMochilaService } from '../services/tipo-mochila.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-tipo-mochila-edit',
  templateUrl: './tipo-mochila-edit.component.html',
  styleUrls: ['./tipo-mochila-edit.component.css'],
  animations: [loadingFade]
})
export class TipoMochilaEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public tipo_mochila_id = null;

  public cores = [{ 'cor': 'Amarelo' },
  { 'cor': 'Azul' },
  { 'cor': 'Branco' },
  { 'cor': 'Cinza' },
  { 'cor': 'Preto' },
  { 'cor': 'Roxo' },
  { 'cor': 'Verde' },
  { 'cor': 'Vermelho' }];


  public formTipoMochila: FormGroup;

  constructor(private route: ActivatedRoute,
    private fb: FormBuilder,
    private tipoMochilaSvc: TipoMochilaService,
    private location: Location,
    private router: Router, ) { }

  ngOnInit() {
    this.criaForm();

    this.loading = true;

    this.route.params.subscribe(params => {
      if (params.id) {
        this.tipo_mochila_id = params.id;
        this.tipoMochilaSvc.getTipoMochila(params.id).then((data: any) => {
          this.preencheForm({
            tipo_mochila_id: data.tipo_mochila_id,
            tipo_mochila_nome: data.tipo_mochila_nome,
            cor: data.cor
          });

          this.loading = false;
        });
      }
      else {
        this.loading = false;
      }
    });
  }

  criaForm() {
    this.formTipoMochila = this.fb.group({
      tipo_mochila_id: null,
      tipo_mochila_nome: ['', Validators.required],
      cor: [null, Validators.required],
    });
  }

  preencheForm(dados) {
    this.formTipoMochila.setValue(dados);
  }

  enviaTipoMochila() {
    if (this.formTipoMochila.valid) {
      this.submitting = true;

      let toSend = this.formTipoMochila.value;

      if (this.tipo_mochila_id === null) { // criar
        this.tipoMochilaSvc.criaTipoMochila(toSend).then((data) => {
          Swal.fire({
            type: 'success',
            title: 'Tipo de mochila cadastrado com sucesso!',
            onClose: () => {
              this.router.navigate(['home/tipomochila']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
        });
      }
      else { // editar
        this.tipoMochilaSvc.editaTipoMochila(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Tipo de mochila alterado com sucesso!',
            onClose: () => {
              this.router.navigate(['home/tipomochila']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
        });
      }
    }
    else {
      for (let field in this.formTipoMochila.controls) {
        let campo = this.formTipoMochila.get(field);
        campo.markAsTouched();
      }
      this.submitting = false;
      Swal.fire({
        type: 'error',
        title: 'Atenção!',
        text: 'Verifique os campos obrigatórios e tente novamente.'
      });
    }
  }

  invalid(nome) {
    let input = this.formTipoMochila.get(nome);
    return input.touched && input.invalid;
  }

  voltar() {
    this.location.back();
  }
}
